import {
  MediaBreakpoints,
  useIsViewPortLessOrEqualTo,
} from '../hooks/useIsViewPortLessOrEqualTo';
import { motion } from 'motion/react';

type SupportedTagName = 'div' | 'header' | 'a';
type MotionLikeComponent = (
  props: Record<string, unknown>,
) => React.JSX.Element;

/**
 * This function creates a motion component based on the provided TagName.
 * It checks if the viewport is less than or equal to 768 pixels wide,
 * and returns a different component accordingly.
 *
 * This exist to disable all motion effects on mobile devices,
 * as they currently affect performance, lighthouse scores.
 *
 * We discarded the idea of using reducedMotion because it will not
 * disable all the animations
 *
 * From the docs;
 * "When reduced motion is on, transform and layout animations will be disabled.
 * Other animations, like opacity and backgroundColor, will persist."
 */

function makeItMotion(TagName: SupportedTagName) {
  return (props: Record<string, unknown>) => {
    const isMobile = useIsViewPortLessOrEqualTo(MediaBreakpoints.MOBILE);
    const MotionTag = (motion as Record<SupportedTagName, MotionLikeComponent>)[
      TagName
    ];
    const Component = isMobile ? TagName : MotionTag;
    return <Component {...props} />;
  };
}

export const DivMotion = makeItMotion('div');
export const HeaderMotion = makeItMotion('header');
export const AMotion = makeItMotion('a');
